import * as React from 'react';
import { useRecordContext } from 'react-admin';

import { Typography } from '@material-ui/core';

import { formatMoeda, getTipoUnidade } from '../../../utils';

const ProdutoField = (props) => {
  const record = useRecordContext(props);
  const valor = record
    ? record.record
      ? `${formatMoeda(record.record.produto.preco_venda)} / ${getTipoUnidade(
          record.record.produto,
        )}`
      : '-'
    : '-';

  return <Typography variant="subtitle1">{valor}</Typography>;
};

export default ProdutoField;
